import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { ExamsService } from '../exams.service';

@Injectable({
  providedIn: 'root'
})
export class CardioService {
  // public Findings;
  public Findings = [];

  public FindingsChange$ = new Subject<string>();
  fields =[ "LeftVentrical", "RightVentrical","Aorta", "Mitral", "Tricuspid", "Aortic", "Pulmonic", "LVOT", "LV", "Septal", "Lateral","LVAfter", "SeptalAfter", "LateralAfter", "LeftAtrium", "RightAtrium","Response","Response","Conduction","ST","EndReason", "ECG"]
  constructor(private http: HttpClient, private es:ExamsService) {
    
   }

  getLVEF(examid:number){
    let params = {'table':'cardio2D',ExamID: examid.toString()};
    return this.http.get("/api/get",{'params':params});
  }

  getHMOinfo(examid:number){
    let params = {'table': 'cardioGeneral',ExamID: examid.toString()};
    return this.http.get("/api/get",{'params': params});
  }

  

   getFindings(){
      return this.http.get('/api/cardio/findings/'+ this.es.examID)
    }


    getAllPatNotes(examID=this.es.examID){
      return this.http.get('/api/cardio/getAllNotes/'+examID);
    }


    savePatNote(form){
      return this.http.post('/api/cardio/savePatNote', {form: form,examID:this.es.examID})
    }

    deleteNote(noteId){
     return this.http.delete(`/api/cardio/PatNote?AutoIndex=${noteId}&ExamID=${this.es.examID}`)
    }

  
  
}
